import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { emailtemplatesApi } from "api/emailtemplates/emailtemplatesApi";

export const useEmailTriggers = () => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.EMAIL_TRIGGERS(),
    queryFn: () => emailtemplatesApi.fetchTriggers(),
  });

  return { loading: isLoading, triggers: data?.data ?? [], refetch };
};
